import * as calendarAPI from "./calendarAPI";
import * as goalAPI from "./goalAPI";
import * as meetingAPI from "./meetingAPI";
import * as socketAPI from "./socketAPI";
import * as surveyAPI from "./surveyAPI";
import * as teamAPI from "./teamAPI";
import * as userAPI from "./userAPI";

window.__TEAMINGAPI__ = {
	...( window.__TEAMINGAPI__ || {} ),
	calendarAPI,
	goalAPI,
	meetingAPI,
	socketAPI,
	surveyAPI,
	teamAPI,
	userAPI,
};

export const API_V1 = 1;
export const API_V2 = 2;

export {
	calendarAPI,
	goalAPI,
	meetingAPI,
	socketAPI,
	surveyAPI,
	teamAPI,
	userAPI
};



// WEBPACK FOOTER //
// ./src/api/index.js